import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "secondarycampaignCopy"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.labelTextArray.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.type == _ctx.typeEnum.SingleText)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              innerHTML: _ctx.labelTextArray[0].text
            }, null, 8, _hoisted_2))
          : (_ctx.type == _ctx.typeEnum.MultipleTextWithLabel)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.labelTextArray, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.label,
                  class: "secondary-campaign-copy-attr-div"
                }, [
                  _createElementVNode("b", {
                    innerHTML: item.label,
                    class: "secondary-campaign-copy-label"
                  }, null, 8, _hoisted_3),
                  _createTextVNode(": "),
                  _createElementVNode("span", {
                    innerHTML: item.text,
                    class: "secondary-campaign-copy-text"
                  }, null, 8, _hoisted_4)
                ]))
              }), 128))
            : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}